import { Button } from "PFComponents/button";
import { SkillsFramework } from "PFTypes";
import React from "react";
import { useTranslation } from "react-i18next";

type SkillsFrameworksButtonProps = {
  onAdd: () => void;
  onRemove: () => void;
  skillsFramework?: SkillsFramework | null;
  disabled?: boolean;
};

export const SkillsFrameworksButton = ({
  onAdd,
  onRemove,
  skillsFramework,
  disabled
}: SkillsFrameworksButtonProps) => {
  const { t } = useTranslation("skillsFrameworks");

  return (
    <Button
      icon={skillsFramework ? "cross" : "add"}
      text={skillsFramework ? skillsFramework.name : t("selectModal.skillsFramework")}
      kind="tertiary"
      small
      onClick={skillsFramework ? onRemove : onAdd}
      disabled={disabled}
    />
  );
};
